import React from "react";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthPages, ProfilePages, ProjectPages} from "./Pages";
import * as routes from "./routes";
import * as Sentry from "@sentry/react";
import { Layout, Common } from "./Components";
import { UserContextProvider } from "./Context";
import { BrowserTracing } from "@sentry/tracing";
import { NotificationProvider } from "./Context/NotificationContext";
import { ProjectSampleFileList } from "./Pages/Projects/Components";

try {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
} catch (error) {
  console.log("Ignore: Sentry init issue!");
}

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          loading: {
            icon: <Common.Spinner size={4} />,
          },
        }}
      />
      <UserContextProvider>
        <NotificationProvider>
          <Routes>
            <Route path={routes.HOME} element={<Layout.Layout />}>
              <Route
                path={routes.HOME}
                element={<ProjectPages.ListProject />}
              />
              <Route path={routes.PROFILE} element={<ProfilePages.Profile />} />
              <Route
                path={routes.CREATE_PROJECT}
                element={<ProjectPages.CreateProject />}
              />
              <Route
                path={routes.VIEW_PROJECT}
                element={<ProjectPages.ProjectDetails />}
              />

              <Route
                path={routes.MANAGE_MATERIALS}
                element={<ProjectPages.ManageMaterials />}
              />
              <Route
                path={routes.USERS_LIST}
                element={<ProjectPages.UserList />}
              />
              <Route
                path={routes.VIEW_SAMPLE}
                element={<ProjectSampleFileList />}
              />
            </Route>

            <Route path={routes.LOGIN} element={<Layout.PublicLayout />}>
              <Route path={routes.LOGIN} element={<AuthPages.LoginForm />} />
            </Route>
            <Route path={routes.SIGNUP} element={<Layout.PublicLayout />}>
              <Route path={routes.SIGNUP} element={<AuthPages.SignUpForm />} />
            </Route>
          </Routes>
        </NotificationProvider>
      </UserContextProvider>
    </>
  );
}

export default App;
